import apiClient from './apiClient.js';
import * as utils from '../utils/utils.js';

export const createEvent = async (
    name,
    gathering_id,
    short_description,
    long_description,
    is_single_event,
    weekday,
    time,
    single_date,
    location,
    min_participants,
    max_participants,
    owner_id,
    notifications,
    notificationType,
    allowGuests
) => {
    const session_url = '/event';
    try {
        const response = await apiClient.post(session_url, {
            name: name,
            short_description: short_description,
            long_description: long_description,
            type: is_single_event ? utils.SINGLE_EVENT : utils.REPEATING_EVENT,
            weekday: is_single_event ? undefined : weekday,
            time_of_day: is_single_event ? undefined : time.format('HH:mm'),
            single_date: is_single_event ? single_date : undefined,
            active: '1',
            venue_id: location,
            min_participants: min_participants,
            max_participants: max_participants,
            owner_id: owner_id,
            gathering_id: gathering_id,
            notifications,
            notificationType,
            is_paused: false,
            allow_guests: allowGuests,
        });

        if (response.status === 201) {
            utils.saveLastCreatedUuid(response.data.event_id);
        }

        return response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
